import { useState } from "react";
import { motion } from "framer-motion";
import { Car, ArrowLeft, ArrowRight, CheckCircle2 } from "lucide-react";

const FIELDS = [
    { key: "marke", label: "Marke", ph: "z.B. BMW" },
    { key: "modell", label: "Modell", ph: "z.B. 320d" },
    { key: "typ", label: "Type / Typschlüssel", ph: "z.B. G20" },
    { key: "variante", label: "Variante", ph: "z.B. Limousine" },
    { key: "motorisierung", label: "Motorisierung", ph: "z.B. 2.0 Diesel" },
    { key: "leistung_kw", label: "Leistung (kW)", ph: "z.B. 140" },
    { key: "leistung_ps", label: "Leistung (PS)", ph: "z.B. 190" },
    { key: "kraftstoff", label: "Kraftstoff", ph: "z.B. Diesel" },
    { key: "fahrgestellnummer", label: "Fahrgestellnummer (FIN)", ph: "WBA...", full: true },
    { key: "fahrzeugklasse", label: "Fahrzeugklasse", ph: "z.B. M1" },
    { key: "baujahr", label: "Baujahr", ph: "z.B. 2021" },
];

export const ReviewStep = ({ vehicle, onComplete, onBack }) => {
    const [data, setData] = useState({
        marke: "",
        modell: "",
        typ: "",
        variante: "",
        motorisierung: "",
        leistung_kw: "",
        leistung_ps: "",
        kraftstoff: "",
        fahrgestellnummer: "",
        fahrzeugklasse: "",
        baujahr: "",
        ...vehicle,
    });

    const update = (k, v) => setData((d) => ({ ...d, [k]: v }));

    const canContinue = data.marke && data.modell && (data.leistung_ps || data.leistung_kw);

    return (
        <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            className="mx-auto max-w-2xl"
        >
            <div className="text-center">
                <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-success/10">
                    <CheckCircle2 className="h-6 w-6 text-success" />
                </div>
                <h2 className="mt-4 font-heading text-2xl font-bold text-white sm:text-3xl">
                    Fahrzeugdaten prüfen
                </h2>
                <p className="mt-2 text-sm text-[#A1A1AA]">
                    Bitte überprüfe die erkannten Werte und korrigiere sie bei Bedarf.
                </p>
            </div>

            <div className="mt-8 rounded-2xl border border-border bg-surface p-5 sm:p-6">
                <div className="mb-5 flex items-center gap-2 text-sm font-medium text-white">
                    <Car className="h-4 w-4 text-primary" /> Fahrzeugdaten
                </div>
                <div className="grid gap-4 sm:grid-cols-2">
                    {FIELDS.map((f) => (
                        <div key={f.key} className={f.full ? "sm:col-span-2" : ""}>
                            <label className="mb-1.5 block text-xs text-[#A1A1AA]">{f.label}</label>
                            <input
                                data-testid={`vehicle-${f.key}`}
                                value={data[f.key] || ""}
                                onChange={(e) => update(f.key, e.target.value)}
                                placeholder={f.ph}
                                className="w-full rounded-md border border-border bg-[#0A0A0A] px-4 py-2.5 text-sm text-white placeholder:text-[#52525B] focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary transition-colors"
                            />
                        </div>
                    ))}
                </div>
            </div>

            <div className="mt-6 flex gap-3">
                <button
                    data-testid="review-back-btn"
                    onClick={onBack}
                    className="inline-flex items-center justify-center gap-2 rounded-md border border-border bg-surface-elevated px-5 py-3.5 text-sm font-medium text-white hover:border-primary/50 transition-colors"
                >
                    <ArrowLeft className="h-4 w-4" /> Zurück
                </button>
                <button
                    data-testid="review-continue-btn"
                    disabled={!canContinue}
                    onClick={() => onComplete(data)}
                    className="group inline-flex flex-1 items-center justify-center gap-2 rounded-md bg-primary px-6 py-3.5 text-base font-bold text-white hover:bg-[#FF3B30] transition-colors disabled:cursor-not-allowed disabled:opacity-40"
                >
                    Weiter zum Performance Check
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                </button>
            </div>
            {!canContinue && (
                <p className="mt-3 text-center text-xs text-[#F59E0B]">
                    Bitte mindestens Marke, Modell und Leistung angeben.
                </p>
            )}
        </motion.div>
    );
};

export default ReviewStep;
